import { Component, Input, OnDestroy } from "@angular/core";
import { Site } from "../../../domain/cloud-topology";
import { Subject } from "rxjs";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-site-operations',
    templateUrl: './site-operations.component.html',
    styleUrls: ['./site-operations.component.scss'],
    standalone: false
})
export class SiteOperationsComponent implements OnDestroy{

  @Input() site: Site;
  info = faInfoCircle;

  private subject$: Subject<void>;

  constructor() {
    this.subject$ = new Subject<void>();
  }

  ngOnDestroy(): void {
    this.subject$.next();
    this.subject$.complete();
  }
}
